<template>
  <!-- 上传文件按钮 -->
  <div class="upload-btn">
    <!-- 原生的上传文件按钮样式很丑，所以这里使用label来制作样式，将原生上传文件按钮隐藏，只使用其选择文件的功能 -->
    <label class="el-button el-button--primary el-button--small">
      {{ label
      }}<input
        ref="fileBtn"
        type="file"
        :accept="fileType"
        @click="handleClick"
        @change="updateFile"
      />
    </label>
  </div>
</template>

<script>
import { putFile } from '@/api/crmedical/contract/add';

export default {
  name: 'UploadBtn',
  props: {
    label: {
      type: String,
      default: '选择图片',
    },
    fileType: {
      type: String,
      default: 'image/png, image/jpeg',
    },
    // 是否开启相同文件的校验，若开启，则连续两次点击同一个文件不会触发change事件
    sameValid: {
      type: Boolean,
      default: true,
    },
    // 文件上传的超时时间，单位毫秒
    fileWaitTime: {
      type: Number,
    },
    // 限制文件大小，不传则不限制
    fileMaxSize: {
      type: Number,
    },
  },
  methods: {
    handleClick() {
      if (!this.sameValid) {
        this.$refs.fileBtn.value = null;
      }
    },
    updateFile() {
      let files = this.$refs.fileBtn.files;
      if (files.length == 0) return;
      const file = files[0];
      if (this.fileMaxSize && file.size > this.fileMaxSize) {
        this.$message.error(`文件不能大于${this.fileMaxSize / (1024 * 1024)}MB`);
        return;
      }
      let fd = new FormData();
      fd.append('file', file);
      let param = {};
      if (this.fileWaitTime) {
        param.timeout = this.fileWaitTime;
      }
      putFile(fd, param).then(({ data }) => {
        data.uid = file.uid;
        if (!data['id'] && data['attachId']) {
          data['id'] = data['attachId'];
        }
        this.$emit('change', data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-btn {
  position: relative;
  input {
    position: absolute;
    opacity: 0;
  }
}
</style>
